module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.client.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Application ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.client_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Platform:")]), _vm._v(" " + _vm._s(this.$store.state.client.platform))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.client.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.client.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Mobile devices total")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/devices")
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientDevicesTotal)))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f373bf50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients/ClientView.vue
// module id = 233
// module chunks = 1